import type { Formation, Player } from '../types/domain'

export const positions = [
  ['ВР', 'Вратарь'], ['ЦЗ', 'Центральный защитник'], ['ЛЦЗ', 'Левый центральный защитник'], ['ПЦЗ', 'Правый центральный защитник'],
  ['ЛЗ', 'Левый защитник'], ['ПЗ', 'Правый защитник'], ['ЛФЗ', 'Левый фланговый защитник'], ['ПФЗ', 'Правый фланговый защитник'],
  ['ЦОП', 'Центральный опорный полузащитник'], ['ЛОП', 'Левый опорный полузащитник'], ['ПОП', 'Правый опорный полузащитник'],
  ['ЦП', 'Центральный полузащитник'], ['ЛЦП', 'Левый центральный полузащитник'], ['ПЦП', 'Правый центральный полузащитник'],
  ['ЦАП', 'Центральный атакующий полузащитник'], ['ЛП', 'Левый полузащитник'], ['ПП', 'Правый полузащитник'],
  ['ЛВ', 'Левый вингер'], ['ПВ', 'Правый вингер'], ['ЦФ', 'Центральный форвард'], ['ЛФ', 'Левый форвард'], ['ПФ', 'Правый форвард'],
] as const

const makeFormation = (name: string, rows: { labels: string[]; y: number }[]): Formation => ({
  id: name, name, slots: rows.flatMap(({ labels, y }) => labels.map((label, index) => ({ label, x: (index + 1) * (100 / (labels.length + 1)), y }))),
})

export const formations: Formation[] = [
  makeFormation('4-3-3', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛЗ','ЦЗ','ЦЗ','ПЗ'], y: 72 }, { labels: ['ЛЦП','ЦОП','ПЦП'], y: 48 }, { labels: ['ЛВ','ЦФ','ПВ'], y: 20 }]),
  makeFormation('4-2-3-1', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛЗ','ЦЗ','ЦЗ','ПЗ'], y: 73 }, { labels: ['ЦОП','ЦОП'], y: 57 }, { labels: ['ЛП','ЦАП','ПП'], y: 38 }, { labels: ['ЦФ'], y: 18 }]),
  makeFormation('4-4-2', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛЗ','ЦЗ','ЦЗ','ПЗ'], y: 72 }, { labels: ['ЛП','ЦП','ЦП','ПП'], y: 48 }, { labels: ['ЛФ','ПФ'], y: 20 }]),
  makeFormation('4-1-4-1', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛЗ','ЦЗ','ЦЗ','ПЗ'], y: 73 }, { labels: ['ЦОП'], y: 59 }, { labels: ['ЛП','ЦП','ЦП','ПП'], y: 40 }, { labels: ['ЦФ'], y: 18 }]),
  makeFormation('3-4-3', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛЦЗ','ЦЗ','ПЦЗ'], y: 72 }, { labels: ['ЛП','ЦП','ЦП','ПП'], y: 48 }, { labels: ['ЛВ','ЦФ','ПВ'], y: 20 }]),
  makeFormation('3-5-2', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛЦЗ','ЦЗ','ПЦЗ'], y: 72 }, { labels: ['ЛП','ЦП','ЦАП','ЦП','ПП'], y: 48 }, { labels: ['ЛФ','ПФ'], y: 20 }]),
  makeFormation('5-3-2', [{ labels: ['ВР'], y: 90 }, { labels: ['ЛФЗ','ЛЦЗ','ЦЗ','ПЦЗ','ПФЗ'], y: 70 }, { labels: ['ЛЦП','ЦП','ПЦП'], y: 45 }, { labels: ['ЛФ','ПФ'], y: 18 }]),
]

export const statusLabels = { starter: 'Основной', rotation: 'Ротация', reserve: 'Резерв', injured: 'Травмирован', unavailable: 'Недоступен' }
export const categoryLabels = { attack: 'Атака', defence: 'Оборона', pressing: 'Прессинг', 'build-up': 'Выход из обороны', counterpress: 'Контрпрессинг', 'transition-attack': 'Переход в атаку', 'transition-defence': 'Переход в оборону', 'set-piece': 'Стандарт', other: 'Другое' }

export type PositionGroup = 'goalkeepers' | 'defenders' | 'midfielders' | 'attackers'
export const positionGroupLabels: Record<PositionGroup, string> = {
  goalkeepers: 'Вратари', defenders: 'Защитники', midfielders: 'Полузащитники', attackers: 'Нападающие',
}

const positionGroups: Record<PositionGroup, string[]> = {
  goalkeepers: ['ВР'],
  defenders: ['ЦЗ','ЛЦЗ','ПЦЗ','ЛЗ','ПЗ','ЛФЗ','ПФЗ'],
  midfielders: ['ЦОП','ЛОП','ПОП','ЦП','ЛЦП','ПЦП','ЦАП','ЛП','ПП'],
  attackers: ['ЛВ','ПВ','ЦФ','ЛФ','ПФ'],
}

export function getPositionGroup(position: string): PositionGroup {
  return (Object.entries(positionGroups).find(([, values]) => values.includes(position))?.[0] as PositionGroup) ?? 'midfielders'
}

const slotCompatibility: Record<string, Record<string, number>> = {
  'ВР': { 'ВР':1000 },
  'ЛЗ': { 'ЛЗ':1000,'ЛФЗ':940,'ЛЦЗ':730,'ЦЗ':620,'ЛП':540,'ЛВ':400 },
  'ПЗ': { 'ПЗ':1000,'ПФЗ':940,'ПЦЗ':730,'ЦЗ':620,'ПП':540,'ПВ':400 },
  'ЛФЗ': { 'ЛФЗ':1000,'ЛЗ':930,'ЛП':750,'ЛВ':610,'ЛЦЗ':550 },
  'ПФЗ': { 'ПФЗ':1000,'ПЗ':930,'ПП':750,'ПВ':610,'ПЦЗ':550 },
  'ЦЗ': { 'ЦЗ':1000,'ЛЦЗ':950,'ПЦЗ':950,'ЛЗ':560,'ПЗ':560,'ЦОП':520 },
  'ЛЦЗ': { 'ЛЦЗ':1000,'ЦЗ':940,'ЛЗ':690,'ПЦЗ':620,'ЦОП':500 },
  'ПЦЗ': { 'ПЦЗ':1000,'ЦЗ':940,'ПЗ':690,'ЛЦЗ':620,'ЦОП':500 },
  'ЦОП': { 'ЦОП':1000,'ЛОП':950,'ПОП':950,'ЦП':780,'ЛЦП':720,'ПЦП':720,'ЦЗ':590 },
  'ЛОП': { 'ЛОП':1000,'ЦОП':920,'ЛЦП':820,'ЦП':720,'ЛП':590 },
  'ПОП': { 'ПОП':1000,'ЦОП':920,'ПЦП':820,'ЦП':720,'ПП':590 },
  'ЦП': { 'ЦП':1000,'ЛЦП':950,'ПЦП':950,'ЦОП':790,'ЦАП':760,'ЛОП':710,'ПОП':710 },
  'ЛЦП': { 'ЛЦП':1000,'ЦП':930,'ЛОП':820,'ЦАП':720,'ЛП':660 },
  'ПЦП': { 'ПЦП':1000,'ЦП':930,'ПОП':820,'ЦАП':720,'ПП':660 },
  'ЦАП': { 'ЦАП':1000,'ЦП':790,'ЛЦП':750,'ПЦП':750,'ЛП':690,'ПП':690,'ЛВ':620,'ПВ':620,'ЦФ':580 },
  'ЛП': { 'ЛП':1000,'ЛВ':900,'ЛФЗ':780,'ЛЦП':720,'ЛЗ':650,'ЦАП':570 },
  'ПП': { 'ПП':1000,'ПВ':900,'ПФЗ':780,'ПЦП':720,'ПЗ':650,'ЦАП':570 },
  'ЛВ': { 'ЛВ':1000,'ЛП':910,'ЛФ':840,'ЦАП':650,'ЛФЗ':570,'ЦФ':520 },
  'ПВ': { 'ПВ':1000,'ПП':910,'ПФ':840,'ЦАП':650,'ПФЗ':570,'ЦФ':520 },
  'ЦФ': { 'ЦФ':1000,'ЛФ':900,'ПФ':900,'ЦАП':620,'ЛВ':560,'ПВ':560 },
  'ЛФ': { 'ЛФ':1000,'ЦФ':930,'ЛВ':850,'ПФ':700,'ЛП':570 },
  'ПФ': { 'ПФ':1000,'ЦФ':930,'ПВ':850,'ЛФ':700,'ПП':570 },
}

function playerSlotScore(player: Player, slot: string) {
  const available = player.status === 'injured' || player.status === 'unavailable' ? -4000 : 0
  const statusBonus = player.status === 'starter' ? 45 : player.status === 'rotation' ? 25 : player.status === 'reserve' ? 10 : 0
  const primary = slotCompatibility[slot]?.[player.primaryPosition] ?? (getPositionGroup(slot) === getPositionGroup(player.primaryPosition) ? 180 : -700)
  const secondary = Math.max(0, ...player.secondaryPositions.map(position => (slotCompatibility[slot]?.[position] ?? 0) - 90))
  return available + statusBonus + Math.max(primary, secondary)
}

/** Подбирает игрока для каждого слота, начиная с самых дефицитных ролей. */
export function buildSmartFormation(players: Player[], formation: Formation) {
  const available = [...players]
  const slots = formation.slots.map((slot, index) => {
    const scores = available.map(player => playerSlotScore(player, slot.label)).sort((a,b) => b-a)
    return { slot, index, priority: (scores[0] ?? -9999) - (scores[1] ?? -9999) + (slot.label === 'ВР' ? 5000 : 0) }
  }).sort((a,b) => b.priority-a.priority)
  const used = new Set<string>()
  const assignments = slots.map(({ slot, index }) => {
    const player = available.filter(candidate => !used.has(candidate.id)).sort((a,b) => playerSlotScore(b,slot.label)-playerSlotScore(a,slot.label))[0]
    if (!player) return undefined
    used.add(player.id)
    return { index, placement:{ playerId:player.id, x:slot.x, y:slot.y } }
  }).filter((item): item is NonNullable<typeof item> => Boolean(item))
  return assignments.sort((a,b) => a.index-b.index).map(item => item.placement)
}
